import React from "react"

// utils
import dayjs from "utils/dates"

// styling
import styled from "@emotion/styled"

// components
import { Row, Col, Space, Typography, List, Divider, Avatar } from "antd"

// configs
import config from "config"
import { useTranslation } from "react-i18next"

const UserReservationList = styled.div`
  .ant-list-item {
    * {
      color: white;
    }
  }

  .ant-tag {
    * {
      color: black;
    }
  }
`

const UserReservationListComponent = ({ data }) => {
  const { t } = useTranslation()

  return (
    <UserReservationList>
      <Divider
        orientation="left"
        style={{
          borderTopColor: config.textColor,
        }}
      >
        <Typography.Title
          level={4}
          italic
          style={{
            fontSize: 20,
            margin: 0,
            color: config.textColor,
            // fontWeight: "lighter",
          }}
        >
          {t("my_reservations")}
        </Typography.Title>
      </Divider>
      <List
        style={{ background: "#4b4b4b" }}
        bordered
        size="small"
        dataSource={data}
        renderItem={(reservation, index) => (
          <List.Item style={{ width: "100%" }}>
            <div style={{ width: "100%" }}>
              <Row justify="space-between" style={{ width: "100%" }}>
                <Col>
                  <Space wrap>
                    <Typography.Text strong>
                      {t("reservation_heading", {
                        id: reservation.id.toUpperCase().slice(0, 4),
                      })}
                    </Typography.Text>
                    <Typography.Text>
                      {(() => {
                        switch (reservation.status) {
                          case "created":
                            return (
                              <Space>
                                <Avatar
                                  src="icon-process/waiting.gif"
                                  size={20}
                                  alt="icon-process-waiting"
                                />
                                <Typography.Text strong>
                                  {t("pending")}
                                </Typography.Text>
                              </Space>
                            )
                          case "accepted":
                            return (
                              <Space>
                                <Avatar
                                  src="icon-process/sucess.png"
                                  size={20}
                                  alt="icon-process-sucess"
                                />
                                <Typography.Text strong>
                                  {t("confirmed")}
                                </Typography.Text>
                              </Space>
                            )
                          case "cancelled-by-user":
                            return (
                              <Space>
                                <Avatar
                                  src="icon-process/refuse.png"
                                  size={20}
                                  alt="icon-process-refuse"
                                />
                                <Typography.Text strong>
                                  {t("canceled")}
                                </Typography.Text>
                              </Space>
                            )
                          case "refused":
                            return (
                              <Space>
                                <Avatar
                                  src="icon-process/refuse.png"
                                  size={20}
                                  alt="icon-process-refuse"
                                />
                                <Typography.Text strong>
                                  {t("canceled")}
                                </Typography.Text>
                              </Space>
                            )
                          default:
                            return t("unknown_reservation_status")
                        }
                      })()}
                    </Typography.Text>

                    <Typography.Text strong>
                      ({reservation.people} {t("people")})
                    </Typography.Text>
                  </Space>
                </Col>
                <Col>
                  <Typography.Text strong>
                    {dayjs(reservation.datetime.toDate()).format(
                      "dddd, D MMMM YYYY HH:mm"
                    )}
                  </Typography.Text>
                </Col>
              </Row>
            </div>
          </List.Item>
        )}
      />
    </UserReservationList>
  )
}

export default UserReservationListComponent
